import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FboActions, FboActionTypes } from './fbo.actions';
import { FboEntity } from './fbo.model';

export interface FboEntities extends EntityState<FboEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FboEntity> = createEntityAdapter<FboEntity>();

export const initialState: FboEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): FboEntities {
  // https://github.com/ngrx/platform/issues/951#issuecomment-425190274
  const action = incomingAction as FboActions;

  switch (action.type) {
    case FboActionTypes.AddFbo: {
      return adapter.addOne(action.payload.fbo, state);
    }

    case FboActionTypes.UpsertFbo: {
      return adapter.upsertOne(action.payload.fbo, state);
    }

    case FboActionTypes.AddFbos: {
      return adapter.addMany(action.payload.fbos, state);
    }

    case FboActionTypes.UpsertFbos: {
      return adapter.upsertMany(action.payload.fbos, state);
    }

    case FboActionTypes.UpdateFbo: {
      return adapter.updateOne(action.payload.fbo, state);
    }

    case FboActionTypes.UpdateFbos: {
      return adapter.updateMany(action.payload.fbos, state);
    }

    case FboActionTypes.DeleteFbo: {
      return adapter.removeOne(action.payload.id, state);
    }

    case FboActionTypes.DeleteFbos: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case FboActionTypes.LoadFbos: {
      return adapter.setAll(action.payload.fbos, state);
    }

    case FboActionTypes.ClearFbos: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
